import { POST } from "../APiHelper/API"


export const addTeamConversationMessage = (team_conversation_id, message, onSuccess, onError) => {
    const data = {
        team_conversation_id: team_conversation_id,
        message: message
    }
    POST("/api/v1/conversations/add_message_for_team", data, onSuccess, onError)
}